const sizeEnumToStringMap = {
  One: '1',
  TwotoTen: '2-10',
  EleventoFifty: '11-50',
  FiftyOnetoTwoHundred: '51-200',
  TwoHundredOnetoFiveHundred: '201-500',
  FiveHundredOnetoOneThousand: '501-1,000',
  OneThousandOnetoFiveThousand: '1,001-5,000',
  FiveThousandOnetoTenThousand: '5,001-10,000',
  OverTenThousand: '> 10,000',
};

export function companySizeEnumToString(enumVal) {
  return sizeEnumToStringMap[enumVal];
}
